import { installDemoFetchInterceptor } from './fetchInterceptor.js';
import { setDemoWriteToastCallback } from './demoStore.js';

export function bootstrapDemoMode(toastFn) {
  installDemoFetchInterceptor();
  if (toastFn) {
    setDemoWriteToastCallback(toastFn);
  }
}